import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 100000000
});
/**
 *
 * Chama todos os usuários
 */
export const fetchAllUsers = async () => {
  try {
    const response = await api.get("/users");

    return response.data;
  } catch (err) {
    detectError(err);
  }
}

/**
 *
 *
 * Utils
 */
const detectError = async (error) => {
  if (error.response) {
    // A requisição foi feita e o servidor respondeu com um código de status
    // que sai do alcance de 2xx
    console.log("A requisição foi feita e o servidor respondeu com um código de status que sai do alcance de 2xx.");
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    // A requisição foi feita mas nenhuma resposta foi recebida
    // `error.request` é uma instância do XMLHttpRequest no navegador e uma instância de
    // http.ClientRequest no node.js
    console.log("A requisição foi feita mas nenhuma resposta foi recebida.");
    console.log(error.request);
  } else {
    // Alguma coisa acontenceu ao configurar a requisição que acionou este erro.
    console.log("Alguma coisa acontenceu ao configurar a requisição que acionou este erro.")
    console.log("Error", error.message);
  }

  console.log(error.config);
}

export default api;